// ============================================================================
// work-order-draft-routed.js — shim over worker-routing-registry (DEC-COUNCIL-007 / C2)
// ----------------------------------------------------------------------------
// Submit logic lives in worker-routing-registry.js. The read helper
// `fetchLatestWorkOrderDraft` stays here because it's not a routing concern.
// ============================================================================

import { apiFetch } from './data-service-api.js';
import { submitJobRouted } from './worker-routing-registry.js';
import { pickModelForTask } from './model-selector.js';

export async function runWorkOrderDraftRouted(args: any) {
    return submitJobRouted('work_order_draft', {
        ...(args || {}),
        model: pickModelForTask('work-order-draft', args?.model),
    });
}

/**
 * Fetch the latest live draft for a project (excludes superseded rows).
 *
 * @param {string} projectId
 * @returns {Promise<object|null>} the draft row (camelCase) or null
 */
export async function fetchLatestWorkOrderDraft(projectId: string) {
    if (!projectId) return null;
    try {
        const { rows } = await apiFetch(`/work-order-drafts?projectId=${encodeURIComponent(projectId)}`);
        return Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
    } catch (err) {
        console.warn(`[QM] fetchLatestWorkOrderDraft failed: ${(err as any)?.message}`);
        return null;
    }
}
